import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/front/13_classic-0/13_classic-0"
 * Contains 12 texture(s)
 */
export class CardsFront13Classic0Atlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/front/13_classic-0/13_classic-0';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        'q-spades.png',
        'q-hearts.png',
        'q-diamonds.png',
        'q-clubs.png',
        'k-spades.png',
        'k-hearts.png',
        'k-diamonds.png',
        'k-clubs.png',
        'j-spades.png',
        'j-hearts.png',
        'j-diamonds.png',
        'j-clubs.png'
    ] as const;
}
